import React from 'react';
import { element, number, shape, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Card, CardTitle } from '@thd-olt-component-react/core-ui';
import { LayoutManager } from '@thd-olt-component-react/layout-manager';
import { TrendingCategories } from '@thd-olt-component-react/thd-recs-containers';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedTrendingInYourNeighborhood({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  store,
  slidesPer,
}) {
  const { storeId, storeZip: zipCode } = store;

  return (
    <LayoutManager name="trending">
      <QueryProvider cacheKey="trending">
        <Hydrator
          id="trendingInYourNeighborhood-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <Card>
            {/**
             * @TODO
             * Refactor `app.scss` to use CSS modules.
             */}
            <CardTitle
              className="card__title u-width-100"
              title="Trending In Your Neighborhood"
            />
            <TrendingCategories
              slidesPer={slidesPer}
              showLoading
              zipCode={+zipCode}
              storeId={storeId}
              hideTitle
            />
          </Card>
        </Hydrator>
      </QueryProvider>
    </LayoutManager>
  );
}

CustomRenderedTrendingInYourNeighborhood.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,

  store: shape({
    storeId: string,
    storeZip: string,
  }),
  slidesPer: number,
};

CustomRenderedTrendingInYourNeighborhood.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,

  store: {
    storeId: '121',
    storeZip: '30339',
  },

  slidesPer: undefined,
};
